<template>
  <div class="comp-custom-field-condition">
    <ly-skeleton v-if="loading && fromPage == 'highFilter'" fromType="filter" :highFilter="fromPage == 'highFilter' ? true : false"></ly-skeleton>
    <jw-spin v-else :loading="loading" class="rule-form-loading">
      <template v-if="filter">
        <!-- 默认数据条件插槽 START -->
        <slot name="default" v-bind="{ conditions: data.ruleForm.conditions, fieldKey: data.ruleForm.fieldKey, fieldOne: data.fieldOne, fieldTwo: data.fieldTwo, fieldThree: data.fieldThree }">
          <jw-form-item :required="required" :asterisk-position="asteriskPosition" :label-col-flex="labelColFlex || ''" class="form-label-text" :show-colon="showColon" style="margin-bottom: 10px">
            <template #label>
              <xl-label-text :value="title || $t('数据条件')" :row="1" />
            </template>
            <jw-input allow-clear v-model="data.ruleForm.fieldKey" :style="{ width: inputWidth || '100%' }" :placeholder="$t('请输入数据条件')" class="drawer-form-item-width">
              <template #prefix>
                <icon-filter />
              </template>
            </jw-input>
          </jw-form-item>
        </slot>
        <!-- 默认数据条件插槽 END -->
      </template>
      <jw-form class="rule-form" ref="editAddForm" :model="data.ruleForm">
        <div :class="['rule-filter-wrap', fromType === 'auto-engine' ? 'auto-engine' : '']">
          <jw-space direction="vertical" :style="{ maxHeight: height ? height + 'px' : '100%', overflowY: height ? 'auto' : 'hidden' }" size="mini" fill>
            <template v-for="(item, index) in data.ruleForm.conditions" :key="index">
              <div class="rule-filter-item">
                <ul :class="['rule-filter-item-wrap', hasMedia ? 'sub-media' : '']">
                  <li class="rule-filter-item-sub" v-for="(sub, i) in item?.children" :key="i">
                    <span class="icon-and">且</span>
                    <!-- <jw-space> -->
                    <!-- 最左侧字段选项 -->
                    <jw-form-item label-col-flex="0" :field="`conditions.${index}.children.${i}.field`" :rules="[{ required: true, message: $t('请选择') }]" class="form-field">
                      <jw-tree-select
                        v-model="sub.field"
                        :data="data.ruleForm.leadsFieldList"
                        @change="changeChild($event, sub)"
                        :placeholder="$t('请选择')"
                        :trigger-props="{ updateAtScroll: true }"
                        allow-search
                        allow-clear
                        :field-names="{
                          key: 'subFieldKey',
                          title: 'fieldName',
                          children: 'childSetting'
                        }"
                        :treeProps="{
                          virtualListProps: {
                            height: 200
                          }
                        }"
                        :filter-tree-node="filterTreeNode"
                        :dropdown-style="{ width: '320px' }"
                        dropdown-class-name="tree-select-condition"
                      >
                        <template #label="{ data }">
                          <div v-if="tools.getStrLen(getFieldName(data.value)) > 10" :title="getFieldName(data.value)">{{ getFieldName(data.value)?.slice(0, 10) + '...' }}</div>
                          <div v-else :title="getFieldName(data.value)">{{ getFieldName(data.value) }}</div>
                        </template>
                      </jw-tree-select>
                    </jw-form-item>
                    <jw-form-item label-col-flex="0" :field="`conditions.${index}.children.${i}.operation`" :rules="[{ required: true, message: $t('请选择规则') }]" class="form-condition">
                      <!-- 企查查特殊处理 -->
                      <jw-select v-if="sub.setting?.fieldKey == 'qccId' || sub.setting?.business?.fieldKey == 'qccId'" class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true }" @change="changeChildTwo($event, sub)" allow-search>
                        <jw-option v-for="item in data.qccID" :key="item.value" :value="item?.value" :title="item.label">{{ item?.label }}</jw-option>
                      </jw-select>
                      <template v-else>
                        <jw-select class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true }" @change="changeChildTwo($event, sub, tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.type)" allow-search>
                          <!-- 条件选择--根据字段类型是24的特殊处理（根据fieldExt中的type再区分条件） -->
                          <template v-if="sub.setting?.fieldType == 24 || sub.setting?.business?.fieldType == 24">
                            <jw-option v-for="item in getConditionFilterType(sub)" :key="item.value" :value="item?.value" :title="item.label">{{ item?.label }}</jw-option>
                          </template>
                          <template v-else>
                            <jw-option :title="item.label" v-for="item in !isCascadingMultiple && (sub.setting?.fieldType == 10 || sub.setting?.business?.fieldType == 10) ? data.ruleForm?.filterType[10]?.filter((v) => v.value !== 'in' && v.value !== 'not_in') : data.ruleForm?.filterType[sub.setting?.fieldType != 21 ? sub.setting?.fieldType : sub.setting?.business?.fieldType]" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
                            <!-- 特殊处理属于当前值 -->
                            <jw-option :title="item.label" v-if="(sub.setting?.fieldType == 12 || sub.setting?.fieldType == 25) && sub.setting?.fieldExt == props.parentEntityId" :value="findAssociation.value">{{ findAssociation.label }}</jw-option>
                          </template>
                        </jw-select>
                      </template>
                    </jw-form-item>
                    <jw-form-item class="form-value" v-if="sub.operation != 'null' && sub.operation != 'not_null' && sub.operation != 'equals_current_value'" label-col-flex="0" :field="`conditions.${index}.children.${i}.value`" :rules="[{ required: true, message: $t('请选择/输入值') }]">
                      <!-- 2，4,3,5 -->
                      <template v-if="checkSelectFieldType(sub)">
                        <fh-select v-if="!(sub.operation == 'null' || sub.operation == 'not_null') && !sub.loading" @change="changeLastChild($event, sub.field)" :multiple="checkMultiple(sub)" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :options="getListOptions(sub)">
                          <template #label="{ data }">
                            <ly-show-filters showType="condition" :showInner="data.label" />
                          </template>
                        </fh-select>

                        <!-- <jw-select v-if="!(sub.operation == 'null' || sub.operation == 'not_null') && !sub.loading" :loading="sub.loading" @change="changeLastChild($event, sub.field)" :multiple="checkMultiple(sub)" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" allow-clear allow-search :max-tag-count="1">
                          <template #label="{ data }">
                            <ly-show-filters showType="condition" :showInner="data.label" />
                          </template>
                          <jw-option v-for="item in getListOptions(sub)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }}</jw-option>
                        </jw-select> -->
                        <div style="width: 0" v-else></div>
                      </template>

                      <!-- 6 人员选择是一个单框与角色权限中的添加人员一样66   -->
                      <template v-else-if="sub?.setting?.fieldType == 6 || sub?.setting?.business?.fieldType == 6">
                        <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                          <fh-person position="bl" :maxTagCount="2" :item="sub" :multiple="sub.operation === 'equals' || sub.operation === 'not_equals' ? false : true" @cb="getValUser($event, index, i)"> </fh-person>

                          <!-- <xl-user-depart @cb="getValUser($event, index, i)" :tree="userTree" :isScreen="true" style="width: 100%" :sub="sub"></xl-user-depart> -->
                        </template>
                        <template v-else>
                          <div style="width: 0"></div>
                        </template>
                      </template>
                      <!-- 7数字 此处会根据接口fieldExt返回的数据：例如：0,1,2,3,(100)%等等判断数字的精度 -->
                      <template v-else-if="(sub.setting?.fieldType === 7 && sub.operation != 'null' && sub.operation != 'not_null') || (sub.setting?.business?.fieldType == 7 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                        <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum)" />
                      </template>
                      <!-- 8：日期格式 -->
                      <template v-else-if="sub.setting?.fieldType == 8 || sub.setting?.business?.fieldType == 8">
                        <!-- 特殊：目前计算字段中（汇总类的数据范围）没有用日期变量，所以将其排除在外 -->
                        <xl-date-variable v-if="props.fromPage !== 'formula'" :objList="sub.setting" :record="sub" @cb="getDateVariable($event, index, i)"></xl-date-variable>
                        <!-- 【处理数据时记得只处理以下部分的数据】，上边日期变量组件的数据不要处理:(只要从接口拿到的原始值) -->
                        <template v-else>
                          <jw-date-picker @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt)?.dataType : sub.setting?.fieldExt" v-if="sub.operation != 'between' && sub.operation != 'null' && sub.operation != 'not_null'" :placeholder="$t('请选择日期范围')" :show-time="isShowTime(sub)" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                          <jw-range-picker type="time-range" @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" v-else-if="sub.operation == 'between'" :show-time="isShowTime(sub)" :format="tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt)?.dataType : sub.setting?.fieldExt" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                          <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                        </template>
                      </template>
                      <!-- 9日期范围 -->
                      <template v-else-if="(sub.setting?.fieldType === 9 && sub.operation != 'null' && sub.operation != 'not_null') || (sub.setting?.business?.fieldType == 9 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <jw-range-picker @change="changeLastChild($event, sub.field)" v-if="sub.setting?.fieldExt == '0' || sub.setting?.business?.fieldExt == '0'" v-model="sub.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker @change="changeLastChild($event, sub.field)" v-else-if="sub.setting?.fieldExt == '1' || sub.setting?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="sub.value" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
                        <jw-range-picker @change="changeLastChild($event, sub.field)" v-else v-model="sub.value" class="rule-form-item-sub-select" @select="onSelect" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :trigger-props="{ updateAtScroll: true }" />
                      </template>
                      <!-- 10 级联选择器 :path-mode="true"-->
                      <template v-else-if="sub.setting?.fieldType == 10 || sub.setting?.business?.fieldType == 10">
                        <jw-cascader :trigger-props="{ updateAtScroll: true }" :max-tag-count="1" :tag-nowrap="true" :path-mode="true" v-if="sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == ''" class="rule-form-item-sub-select" :options="JSON.parse(sub.setting?.fieldType != 21 ? sub.setting?.fieldExt ?? '[]' : sub.setting?.business?.fieldExt ?? '[]')" allow-search v-model="sub.value" @change="changeLastChild($event, sub.field)" :placeholder="$t('请选择')">
                          <template #label="{ data }">
                            <ly-show-filters showType="condition" :showInner="data.label" />
                          </template>
                        </jw-cascader>
                        <jw-cascader :trigger-props="{ updateAtScroll: true }" :max-tag-count="1" :tag-nowrap="true" :path-mode="true" v-else-if="sub.operation == 'in' || sub.operation == 'not_in'" class="rule-form-item-sub-select" :options="JSON.parse(sub.setting?.fieldType != 21 ? sub.setting?.fieldExt ?? '[]' : sub.setting?.business?.fieldExt ?? '[]')" allow-search v-model="sub.value" @change="changeLastChild($event, sub.field)" :placeholder="$t('请选择')" multiple>
                          <template #label="{ data }">
                            <ly-show-filters showType="condition" :showInner="data.label" />
                          </template>
                        </jw-cascader>
                        <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                      </template>
                      <!-- 16 金额 -->
                      <template v-else-if="sub?.setting?.fieldType === 16 || sub?.setting?.business?.fieldType == 16">
                        <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum)" />
                        <div v-else style="width: 0"></div>
                      </template>
                      <!-- 22 部门 -->
                      <template v-else-if="sub?.setting?.fieldType == 22 || sub?.setting?.business?.fieldType == 22">
                        <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                          <xl-user-depart @cb="getValUser($event, index, i)" :isScreen="true" :tree="departTree" style="width: 100%" :sub="sub"></xl-user-depart>
                        </template>
                        <template v-else>
                          <!-- <xl-tree-member-modal :popup="popup" :tree="departTree" v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @cb="getValUser($event, index, i)" :multipleDep="sub.operation == 'equals' || sub.operation == 'not_equals' ? false : true" :depart="sub.departList">
                            <jw-input-tag v-model="sub.userDept" :max-tag-count="2" class="rule-form-item-sub-select" readonly :placeholder="$t('请选择')" />
                          </xl-tree-member-modal> -->
                          <div style="width: 0"></div>
                        </template>
                      </template>
                      <!-- 23百分比 -->
                      <template v-else-if="(sub?.setting?.fieldType === 23 && sub.operation != 'null' && sub.operation != 'not_null') || (sub?.setting?.business?.fieldType == 23 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                        <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :precision="getPrecision(sub, precisionNum)">
                          <template #append> % </template>
                        </jw-input-number>
                      </template>
                      <!-- 24计算字段 -->
                      <template v-else-if="(sub.setting?.fieldType === 24 && sub.operation != 'null' && sub.operation != 'not_null') || (sub.setting?.business?.fieldType == 24 && sub.operation != 'null' && sub.operation != 'not_null')">
                        <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
                        <template v-if="getConditionType(sub, [5, 7])">
                          <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                          <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum, true)" />
                        </template>
                        <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
                        <template v-else-if="getConditionType(sub, [6, 16])">
                          <jw-input-number v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum, true)" />
                          <div v-else style="width: 0"></div>
                        </template>
                        <!-- 计算字段的fieldExt的type=0 :文本 -->
                        <template v-else-if="getConditionType(sub, [0])">
                          <jw-input v-model.trim="sub.value" :placeholder="$t('请输入')" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" />
                        </template>
                        <!-- 计算字段的fieldExt的type=23 :百分比 -->
                        <template v-else-if="getConditionType(sub, [23])">
                          <div style="width: 0" v-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                          <jw-input-number @change="changeLastChild($event, sub.field)" v-else class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :precision="getPrecision(sub, precisionNum, true)">
                            <template #append> % </template>
                          </jw-input-number>
                        </template>
                        <!-- 计算字段的fieldExt的type=8 :日期 -->
                        <template v-else-if="getConditionType(sub, [8])">
                          <jw-date-picker @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="sub.setting?.fieldType != 21 ? JSON.parse(sub.setting?.fieldExt)?.dataType : JSON.parse(sub.setting?.business?.fieldExt)?.dataType" v-if="sub.operation != 'between' && sub.operation != 'null' && sub.operation != 'not_null'" :placeholder="$t('请选择日期范围')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                          <jw-range-picker type="time-range" @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="sub.setting?.fieldType != 21 ? JSON.parse(sub.setting?.fieldExt)?.dataType : JSON.parse(sub.setting?.business?.fieldExt)?.dataType" v-else-if="sub.operation == 'between'" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                          <div style="width: 0" v-else-if="sub.operation == 'null' || sub.operation == 'not_null'"></div>
                        </template>
                      </template>
                      <!-- 单行文本 obj[sub.field] -->
                      <template v-else>
                        <jw-input v-model.trim="sub.value" :input-attrs="{ type: 'search' }" :name="'conditionschildren'" :field="`conditions.${index}.children.${i}.value`" :placeholder="$t('请输入')" @change="changeLastChild($event, sub)" class="rule-form-item-sub-select" />
                      </template>
                    </jw-form-item>
                    <template v-else>
                      <div style="width: 0"></div>
                    </template>
                    <icon-minus-circle class="form-icon hand" @click="conditionUpdate(1, index, i)" v-if="!required || (required && (item.children?.length > 1 || i != 0))" :size="20" />
                    <!-- </jw-space> -->
                  </li>
                  <li class="rule-filter-item-sub">
                    <icon-plus-circle class="add-sub-item hand" @click="conditionUpdate(1, index)" />
                  </li>
                </ul>
                <!-- 必填时  条件组至少保留一个 -->
                <icon-close-circle-fill v-if="!required || (required && (data.ruleForm.conditions?.length > 1 || index != 0))" @click="conditionUpdate(0, index)" class="del-item" :size="20" />
              </div>
              <jw-divider orientation="center" v-if="index !== data.ruleForm.conditions.length - 1">或（or）</jw-divider>
            </template>
          </jw-space>
          <div class="footer-btn" v-if="isFirstFlag">
            <jw-button size="small" type="outline" @click="conditionUpdate(0)">
              <template #icon>
                <icon-plus />
              </template>
              {{ $t('新增或关系') }}
            </jw-button>
            <slot name="btn"> </slot>
          </div>
        </div>
      </jw-form>
    </jw-spin>
  </div>
</template>
<script setup>
import _ from 'lodash';
import { reactive, ref, computed, watch, inject } from 'vue';
import { Message } from '@arco-design/web-vue';
import { setService, biService } from '@/api/';
import useLoading from '@/hooks/loading';
import dayjs from 'dayjs';
import { tools } from '@/utils/tools';
import { useConditionStore } from '@/store';
import FhSelect from '@/components/fh-select/fh-select.vue';

// 精度
import useThousandOption from '@/hooks/thousand';
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();
const { loading, setLoading } = useLoading(false);

import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/store';
const { userInfo } = useUserStore(); //用户信息
const { t } = useI18n();
const editAddForm = ref();
const props = defineProps({
  popup: {
    type: String,
    default: 'body'
  },
  title: {
    type: String,
    default: ''
  },
  parentEntityId: {
    type: String
  },
  labelColFlex: {
    type: [String, Number]
  },
  inputWidth: {
    type: String
  },
  showColon: {
    type: Boolean,
    default: true
  },
  required: {
    type: Boolean,
    default: false
  },
  asteriskPosition: {
    type: String,
    default: 'start'
  },
  entity: {
    type: Number,
    default: 0
  },
  filter: {
    type: Boolean,
    default: true
  },
  // 开启高级搜索
  isScreen: {
    type: Boolean,
    default: false
  },
  children: {
    type: Array,
    default: () => [] //field:null,value:null,operation:null,isGroup:false
  },
  fieldKey: {
    type: String,
    default: ''
  },
  fromPage: {
    //echart :图表来源 engine:自动化流程
    type: String
  },
  chartId: {
    //图标id
    type: [String, Number],
    default: ''
  },
  // 条件组件高度
  height: {
    type: [String, Number],
    default: ''
  },
  // 是否展示常用检索
  isDetailTable: {
    type: Boolean,
    default: false
  },
  //默认筛选分组  1 默认初始化一个条件
  defaultConditions: {
    type: [String, Number],
    default: 0
  },
  isCascadingMultiple: {
    type: Boolean,
    default: true
  },
  isFilterDateRange: {
    type: Boolean,
    default: false
  },
  // 是否返回字段setting
  isReturnSetting: {
    type: Boolean,
    default: false
  },
  fromType: {
    /* 来源：自动化流程样式特殊调整 */
    type: String
  },
  hasMedia: {
    type: Boolean
  }
});
const conditionStore = useConditionStore();
const isFirstFlag = ref(false);
const emits = defineEmits(['cb', 'setCondition']);
const entityId = computed(() => props.entity);
const childrenData = ref([]);
const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
const objectFormDataMethods = inject('objectFormDataMethods'); //调用父组件方法(新增字段时数据范围来源（查找关联，编码)
const gettempSettingIds =
  objectFormDataMethods?.gettempSettingIds ||
  (() => {
    return '';
  }); //获取布局新增的字段 但是布局并没有保存字段信息
// 获取本次布局禁用的字段信息
const gettempDisableSettingIds =
  objectFormDataMethods?.gettempDisableSettingIds ||
  (() => {
    return '';
  });

/****************************************/
const data = reactive({
  orgId: userInfo?.orgId, //组织id
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
  },
  fieldNames: { value: 'fieldKey', label: 'fieldName' },
  fieldOne: '',
  fieldTwo: '',
  fieldThree: '',
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ]
});

// 判断字段类型
const checkSelectFieldType = (sub) => {
  const selectTypes = [2, 4, 3, 5];
  return selectTypes.includes(sub.setting?.fieldType) || selectTypes.includes(sub.setting?.business?.fieldType);
};

// 获取下拉列表
const getListOptions = (sub) => {
  const extInfo = sub.setting?.fieldType != 21 ? sub.setting?.fieldExt : sub.setting?.business?.fieldExt;
  return tools.isJSON(extInfo) ? JSON.parse(extInfo) : extInfo;
};

// 判断是否多选
const checkMultiple = (sub) => {
  if (sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == '') {
    return false;
  }
  return true;
};

/**************************************************************************************/
const filterTreeNode = (searchValue, nodeData) => {
  if (nodeData?.fieldType == 27) {
    //子表单
    return nodeData?.childSetting?.find((el) => el?.fieldName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
  } else {
    return nodeData.fieldName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
  }
};
// 获取显示的名称
const getFieldName = (value) => {
  const getItem = data.ruleForm.leadsFieldList?.find((el) => {
    // 检查当前项是否直接匹配
    if (el.subFieldKey === value) {
      return el; // 返回 true 表示当前项匹配
    }
    // 检查子设置中是否有匹配项
    if (el?.childSetting && el.childSetting.find((item) => item.subFieldKey === value)) {
      return el; // 返回 true 表示子设置中有匹配项
    }
    // 如果当前项或子设置中都没有匹配项，则返回 false
    return undefined;
  });
  console.log(360, getItem);
  if (getItem?.fieldType == 27) {
    return getItem?.childSetting?.find((item) => item.subFieldKey === value)?.setFieldName || '';
  } else {
    return getItem?.setFieldName || '';
  }
};
// 获取条件下拉选择
const getConditionFilterType = (sub) => {
  let list = [];
  const fieldType = sub?.setting?.fieldType;
  const drf = data.ruleForm?.filterType;
  if (fieldType == 21) {
    if (sub.setting?.business?.fieldType == 24) {
      const businessFieldExt = tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt);
      list = drf[sub.setting?.business?.fieldType][businessFieldExt?.type];
    } else {
      list = drf[sub.setting?.business?.fieldType];
    }
  } else if (fieldType == 24 && sub.setting?.fieldType == 21) {
    if (sub.setting?.business?.fieldType == 24) {
      const fieldExt = tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt);
      list = drf[sub.setting?.business?.fieldType][fieldExt?.type];
    } else {
      list = drf[sub.setting?.business?.fieldType];
    }
  } else {
    if (sub.setting?.fieldType == 24) {
      const fieldExt = tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt);
      list = drf[sub.setting?.fieldType][fieldExt?.type];
    } else {
      list = drf[sub.setting?.fieldType];
    }
  }
  return list;
};
// 计算字段的判断条件
const getConditionType = (sub, type) => {
  const isFieldExtJSON = tools.isJSON(sub.setting?.fieldExt);
  const isBusinessFieldExtJSON = tools.isJSON(sub.setting?.business?.fieldExt);

  let shouldRender = false;

  if (isFieldExtJSON || isBusinessFieldExtJSON) {
    const fieldExtType = isFieldExtJSON ? JSON.parse(sub.setting?.fieldExt)?.type : null;
    const businessFieldExtType = isBusinessFieldExtJSON ? JSON.parse(sub.setting?.business?.fieldExt)?.type : null;

    const isTypeValid = type.includes(fieldExtType) || type.includes(businessFieldExtType);
    const isOperationValid = sub.operation !== 'null' && sub.operation !== 'not_null';

    shouldRender = isTypeValid && isOperationValid;
  }

  return shouldRender;
};
// 是否展示时间
const isShowTime = (sub) => {
  const ext = sub?.setting?.fieldType != 21 ? sub.setting?.fieldExt : sub.setting?.business?.fieldExt;
  if (!ext) return false;
  if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
    return true;
  } else {
    return false;
  }
};
const getValUser = (v, index, i) => {
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  const ud = data.ruleForm.conditions[index].children[i];
  ud.userDept = [...userNames.value, ...departNames.value];
  ud.userList = v.userList;
  ud.departList = v.departList;
  const userIds = ud.userList?.map((c) => c.id);
  const departIds = ud.departList?.map((c) => c.id);
  ud.value = JSON.stringify({
    userIds,
    departIds
  });
  if (ud.operation === 'equals' || ud.operation == 'not_equals') {
    if (ud.userDept.length > 1) {
      Message.warning(t('请注意，只可选择一个人员或部门哦'));
    }
  }
  editAddForm.value.validateField(`conditions.${index}.children.${i}.value`);
  emits('cb', updateCondition());
};
// 自动化流程引擎对字段的特殊处理
const sysField = ['gmtUpdated', 'lastUpdateUser', 'lastUpdateTime', 'updateUser'];

// 获取条件下字段类型
const getFilter = async () => {
  if (data.lastEntityId && data.lastEntityId == entityId.value) {
    return true;
  }
  let res = {};
  if (props.fromPage == 'echart') {
    //图表用新接口
    res = await biService.getEntityField({ entityType: entityId.value, chartId: props?.chartId || null });
    // 过滤 关联对象名称 关联对象数据
    res.result.fields = res.result?.fields?.filter((v) => v.fieldKey != 'businessId' && v.fieldKey != 'entityType');
    // 过滤生命状态字段的 已作废
    res.result?.fields?.forEach((item) => {
      if (item.fieldType == '4' && item.fieldKey == 'status' && tools.isJSON(item.fieldExt)) {
        const fieldExtArray = JSON.parse(item.fieldExt)?.filter((e) => e.value != '4');
        item.fieldExt = JSON.stringify(fieldExtArray);
      }
    });
  } else {
    const params = { entity: entityId.value, apiIndex: Math.random() };
    if (gettempSettingIds()) {
      params.tempSettingIds = gettempSettingIds();
    }
    if (gettempDisableSettingIds()) {
      params.tempDisableSettingIds = gettempDisableSettingIds() || '';
    }
    if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
      //如果是计算类型或者条件编码
      res = await conditionStore.getEntityFieldsList(params);
    } else {
      res = await conditionStore.getEntityFields(params);
    }
    // 过滤 关联对象名称 关联对象数据
    res.result = res.result.filter((v) => v.fieldKey != 'businessId');
    // 过滤生命状态字段的 已作废
    res.result?.forEach((item) => {
      if (item.fieldType == '4' && item.fieldKey == 'status' && tools.isJSON(item.fieldExt)) {
        const fieldExtArray = JSON.parse(item.fieldExt)?.filter((e) => e.value != '4');
        item.fieldExt = JSON.stringify(fieldExtArray);
      }
    });
  }

  data.filterTypeArray = res.result;
  if (props.fromPage === 'codingRule') {
    data.ruleForm.leadsFieldList = res.result.filter((v) => v.fieldType !== 24);
  } else if (props.fromPage === 'echart') {
    data.ruleForm.leadsFieldList = res.result?.fields?.filter((i) => i.isEnabled === true && i.fieldType !== 27) || [];
  } else if (props.fromPage === 'layout') {
    data.ruleForm.leadsFieldList = res.result?.filter((v) => v.fieldType !== 27) || [];
  } else if (props.fromPage === 'engine') {
    data.ruleForm.leadsFieldList = res.result?.filter((v) => ![27].includes(v.fieldType || v?.business?.fieldType) && !sysField.includes(v.fieldKey || v?.business?.fieldKey)) || [];
  } else {
    data.ruleForm.leadsFieldList = res.result;
  }
  //props.isFilterDateRange阶段流程的特殊处理（过滤掉日哦其范围字段，之后支持日期范围时解开）
  if (props.isFilterDateRange) {
    data.ruleForm.leadsFieldList = data.ruleForm.leadsFieldList.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18))?.filter((m) => m.fieldType !== 9);
  } else {
    // 过滤附件
    data.ruleForm.leadsFieldList = data.ruleForm.leadsFieldList.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18));
  }

  data.ruleForm.leadsFieldList?.forEach((item, index) => {
    if (item.fieldType == 10) {
      item.fieldExt = item.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
    } else if (item?.business?.fieldType == 10) {
      item.business.fieldExt = item.business?.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
    }
    item.key = `0-${index}`;
    item.subFieldKey = item.fieldKey;
    item.setFieldName = item.fieldName;
    item.arr = [];
    if (item.fieldType == 27) {
      item.disabled = true;
      console.log(488, item);
      item?.childSetting?.forEach((k, kIndex) => {
        k.key = `0-${index}-${kIndex}`;
        k.subFieldKey = item.fieldKey + '.' + k.fieldKey;
        k.setFieldName = item.fieldName + '.' + k.fieldName;
        data.ruleForm.filterType[item.fieldKey + '.' + k.fieldKey] = k;
        item.arr.push(item.fieldKey + '.' + k.fieldKey);
      });
    } else {
      data.ruleForm.filterType[item.fieldKey] = item;
    }
  });

  console.log('最终数据333', data.ruleForm.leadsFieldList);

  try {
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    if (!json.error) {
      json.result?.forEach((item) => {
        if (item.fieldType == 24) {
          data.ruleForm.filterType[item.fieldType] = item.computeMaps; //第二个框
        } else if ([12, 25].includes(item.fieldType) && props.fromPage === 'engine') {
          // 自动化 查找关联字段过滤操作项
          data.ruleForm.filterType[item.fieldType] = item.conditions?.filter((d) => ['null', 'not_null'].includes(d.value));
        } else {
          data.ruleForm.filterType[item.fieldType] = item.conditions; //第二个框
        }
      });
      if (props.parentEntityId) {
        data.qccID.push(findAssociation);
      }
    }
  } catch (e) {
    console.log(e);
  }
  //缓存本次更新的entityId
  data.lastEntityId = entityId.value;
};
// 日期类型获取日期变量
const getDateVariable = (record, index, i) => {
  data.ruleForm.conditions[index].children[i].value = record;
  if (record) emits('cb', updateCondition());
};
// 第一个框change事件
const changeChild = async (e, sub) => {
  // const sub = data.ruleForm.conditions[index][i];
  console.log('改变的数据1', e, sub);
  if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
    sub.loading = true;
  }
  await setConditionsFieldSetting(data.ruleForm.conditions);
  sub.operation = '';
  sub.value = null;
  sub.business = [];
  sub.userDept = [];
  sub.userDeptIds = [];
  sub.departList = [];
  sub.userList = [];
  sub.remark = null;
  sub.fieldType = sub?.setting?.fieldType;
  sub.field = e;
  sub.isExpand = false;
  if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
    //如果是计算类型或者条件编码
    const fieldExtData = await setService.sysEntityfieldExt({ settingId: sub.setting.id, apiIndex: Math.random() });
    if (!fieldExtData.error) {
      if (sub?.setting?.fieldType == 21) {
        sub.setting.business = fieldExtData?.result?.business;
        sub.setting.fieldExt = fieldExtData?.result?.fieldExt;
      } else {
        sub.setting.fieldExt = fieldExtData?.result?.fieldExt;
      }
    }
    sub.loading = false;
  }
  data.fieldThree = '';
  data.ruleForm.leadsFieldList.find(async (item) => {
    if (item.fieldType == 27) {
      //子表
      item?.childSetting?.find(async (el) => {
        if (el.subFieldKey === e) {
          if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
            //如果是计算类型或者条件编码
            const fieldExtData = await setService.sysEntityfieldExt({ settingId: el.id, apiIndex: Math.random() });
            data.fieldOne = el.fieldName;
            if (!fieldExtData.error) {
              sub.fieldExt = fieldExtData?.result?.fieldExt;
            }
          } else {
            data.fieldOne = el.fieldName;
            sub.fieldExt = el.fieldExt;
          }
        }
      });
    } else {
      if (item.subFieldKey === e) {
        if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
          //如果是计算类型或者条件编码
          const fieldExtData = await setService.sysEntityfieldExt({ settingId: item.id, apiIndex: Math.random() });
          data.fieldOne = item.fieldName;
          if (!fieldExtData.error) {
            sub.fieldExt = fieldExtData?.result?.fieldExt;
          }
        } else {
          data.fieldOne = item.fieldName;
          sub.fieldExt = item.fieldExt;
        }
      }
    }
  });

  console.log('改变的数据2', sub);

  await condition();
};
// 第二个change事件
const changeChildTwo = (e, sub, type) => {
  console.log('changeChildTwo', e, sub, type);
  sub.value = '';
  if (sub?.userDept || sub?.departList || sub?.userList) {
    sub.userDept = [];
    sub.userDeptIds = [];
    sub.departList = [];
    sub.userList = [];
  }
  const arr = Object.values(data.ruleForm.filterType);
  arr?.forEach((item) => {
    // 对计算字段24的条件进行特殊处理
    item = Array.isArray(item) ? item : item[type];
    item?.forEach((i) => {
      if (i.value == e) {
        data.fieldTwo = i.label;
      }
    });
  });
  condition();
  if (e == 'null' || e == 'not_null') emits('cb', updateCondition());
};
//数据选中事件
const condition = async () => {
  if (data.ruleForm?.conditions?.length < 1) {
    data.ruleForm.fieldKey = t('全部数据');
  } else if (data.ruleForm?.conditions?.length < 2) {
    data.ruleForm.fieldKey = '筛选 ·' + ' ' + data.fieldOne + ' ' + data.fieldTwo + ' ' + data.fieldThree;
  } else {
    data.ruleForm.fieldKey = '筛选 ·' + ' ' + data.ruleForm?.conditions?.length;
  }
};
//最后框
const changeLastChild = (e, sub) => {
  if (Array.isArray(e)) {
    data.fieldThree = e[0] ?? '';
  } else {
    data.fieldThree = e ?? '';
  }
  condition();
  console.log('changeLastChild', sub);
  emits('cb', updateCondition());
};
//新增或关系
const conditionUpdate = (tp, index, i) => {
  console.log('tp, index, i', tp, index, i);
  if (tp) {
    // 子级
    if (i === undefined) {
      data.ruleForm.conditions[index].children?.push({ id: undefined, parentId: undefined, field: '', fieldType: '', operation: '', value: null, isGroup: false });
    } else {
      data.ruleForm.conditions[index].children?.splice(i, 1);
      if (!data.ruleForm.conditions[index]?.children?.length) {
        data.ruleForm.conditions?.splice(index, 1);
      }
      emits('cb', updateCondition());
    }
  } else {
    // 父级
    if (index === undefined) {
      data.ruleForm.conditions?.push({ id: undefined, parentId: undefined, operation: 'and', field: '', fieldType: '', value: null, isGroup: true, children: [{ id: undefined, parentId: undefined, field: props?.fieldKey || '', fieldType: '', operation: '', value: null, isGroup: false }] });
    } else {
      data.ruleForm.conditions?.splice(index, 1);
      emits('cb', updateCondition());
    }
  }
  condition();
};

// 级联
const isCascader = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10) {
    return true;
  } else {
    return false;
  }
};

// 日期 日期区间
const isDteTime = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 8 || child.setting?.business?.fieldType === 8 || child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [8]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [8]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 日期区间
const isDateRange = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9) {
    return true;
  } else {
    return false;
  }
};

// 数字
const isNumber = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 7 || child.setting?.business?.fieldType === 7 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 金额
const isPrice = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 16 || child.setting?.business?.fieldType === 16 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 百分比
const isPercentage = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 23 || child.setting?.business?.fieldType === 23 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [23]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [23]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 人员部门
const isUserDepartment = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 6 || child.setting?.business?.fieldType === 6 || child.setting.fieldType === 22 || child.setting?.business?.fieldType === 22) {
    return true;
  } else {
    return false;
  }
};

const getConditions = async () => {
  try {
    const conditions = childrenData.value;
    if (!conditions || conditions.length == 0) {
      if (props.fromPage == 'highFilter') {
        data.ruleForm.conditions = [{ id: undefined, parentId: undefined, operation: 'and', field: '', fieldType: '', value: null, isGroup: true, children: [{ id: undefined, parentId: undefined, field: '', fieldType: '', operation: '', value: null, isGroup: false }] }];
      }
      data.ruleForm.fieldKey = t('全部数据');
    } else {
      //回显请求开始----
      console.log('565656565656565656', data.ruleForm.conditions);
      if (props.fromPage === 'formula' || props.fromPage === 'codingRule') {
        //如果是计算类型或者条件编码
        // 创建一个Promise数组来保存所有请求
        const fetchFieldExtPromises = [];
        // 遍历每个条件组
        conditions.forEach((element) => {
          if (element.children) {
            element.children.forEach((item) => {
              // 排除 单行文本  多行文本  超链接  富文本 无需请求fieldExt
              if (item.setting && item.setting?.id && item.setting?.fieldType != 0 && item.setting?.fieldType != 1 && item.setting?.fieldType != 11 && item.setting?.fieldType != 26) {
                // 对每个条件发起请求，并将Promise加入到fetchFieldExtPromises数组
                fetchFieldExtPromises.push(fetchFieldExtData(item));
              }
            });
          }
        });

        // 等待所有的请求完成
        await Promise.all(fetchFieldExtPromises);
      }
      //回显请求结束----
      console.log('开始解析数据', JSON.parse(JSON.stringify(conditions)));
      conditions?.forEach((item) => {
        item.children?.forEach((sub) => {
          // 处理子表单的回显
          const remarkFieldKey = sub?.remark && sub.remark !== '' && tools.isJSON(sub.remark) ? JSON.parse(sub.remark)?.fieldKey : '';
          if (remarkFieldKey) {
            console.log(736, sub);
            sub.field = sub.field + '.' + remarkFieldKey;
            const fieldObj = data.ruleForm.leadsFieldList?.find((k) => k?.fieldKey == sub.field || k.arr?.includes(sub.field));
            if (fieldObj) {
              sub.setting = fieldObj;
              if (fieldObj?.childSetting?.length) {
                fieldObj.childSetting?.forEach((m) => {
                  if (sub.field?.split('.')?.[1] == m.fieldKey) {
                    sub.setting = m;
                  }
                });
              }
            }
          }
          if (isUserDepartment(sub) && (sub.operation != 'null' || sub.operation != 'not_null')) {
            sub.value = _.isString(sub.value) && sub?.business && Object.keys(sub?.business)?.length > 0 ? sub.business : sub.value;
            if (_.isString(sub.value) || _.isArray(sub.value)) {
              return false;
            }
            const dept = sub.value?.departIds?.map((v) => v.name) || [];
            const user = sub.value?.userIds?.map((v) => v.name) || [];
            const userIds = sub.value?.userIds?.map((v) => v.id || []);
            const departIds = sub.value?.departIds?.map((v) => v.id || []);
            sub.userDept = [...dept, ...user];
            if (userIds) sub.userDeptIds = [...userIds];
            if (departIds) sub.userDeptIds = [...departIds];
            sub.userList = sub.value?.userIds?.map((v) => {
              return {
                ...v,
                userName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.departList = sub.value?.departIds?.map((v) => {
              return {
                ...v,
                departmentName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.value = JSON.stringify({
              userIds: userIds,
              departIds: departIds
            });
            sub.business = null;
          }
          if (sub.operation === 'in' || sub.operation === 'not_in') {
            if (_.isString(sub.value)) {
              if (isCascader(sub) && sub.value?.includes('/')) {
                sub.value = sub.value?.split(',')?.map((str) => str?.split('/'));
              } else {
                sub.value = sub?.value?.split(',');
              }
            }
          } else if (props.fromPage === 'formula' && sub.operation === 'between') {
            // 在区间（日期类型）
            if (isDteTime(sub)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              const datesArray = [parsedObject.beginDate, parsedObject.endDate];
              sub.value = datesArray;
            }
          } else if (isCascader(sub) && (sub.operation == 'equals' || sub.operation == 'not_equals')) {
            console.log(667, sub.value);
            sub.value = sub.value && typeof sub.value === 'string' ? sub.value?.split('/') : sub?.value;
            console.log(668, sub.value);
          } else if (sub.operation === 'between') {
            if (isDateRange(sub)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              const datesArray = [parsedObject.beginDate, parsedObject.endDate];
              sub.value = datesArray;
            }
          } else {
            // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
            sub.value = Array.isArray(sub.value) ? sub.value?.join() : sub.value;
          }
          // 处理数字
          if (isNumber(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value);
          }
          // 处理价格
          if (isPrice(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value) / 10000;
          }
          // 处理百分比字段类型
          if (isPercentage(sub) && sub.operation != 'null' && sub.operation != 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) {
              let fieldExt = '';
              if (sub.setting.fieldType === 21) {
                if (sub.setting?.business?.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.numberFormat) || 2;
                }
              } else {
                if (sub.setting.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.numberFormat) || 2;
                }
              }
              sub.value = tools.getPercentage(sub.value, fieldExt);
            }
          }
        });
      });
      console.log('显示条件内容数据 ---- custom', JSON.parse(JSON.stringify(conditions)));
      data.ruleForm.conditions = conditions;
    }
  } catch (e) {
    console.log(e, '失败了');
  }
  setLoading(false);
  isFirstFlag.value = true;
};
// 获取单个用户的详细信息的方法
const fetchFieldExtData = async (field) => {
  try {
    field.loading = true; // 开始加载时设置为true
    const fieldExtData = await setService.sysEntityfieldExt({ settingId: field.setting.id, apiIndex: Math.random() });
    if (!fieldExtData.error) {
      if (field?.setting?.fieldType == 21) {
        field.setting.fieldExt = fieldExtData?.result?.fieldExt;
        field.setting.business = fieldExtData?.result?.business;
      } else {
        field.setting.fieldExt = fieldExtData?.result?.fieldExt;
      }
    }
  } catch (err) {
    console.error(`无法获取 ${field.field}的fieldExt`, err);
  } finally {
    field.loading = false; // 请求完成后设置为false
  }
};
// 追加字段属性
const setConditionsFieldSetting = async (array) => {
  console.log(798, data.ruleForm.leadsFieldList);
  array?.forEach((item) => {
    item?.children?.forEach((el) => {
      const fieldObj = data.ruleForm.leadsFieldList?.find((sub) => sub?.fieldKey == el.field || sub.arr?.includes(el.field));
      if (fieldObj) {
        el.setting = fieldObj;
        // const mObj = fieldObj?.childSetting?.find((m) => m.fieldKey == el.field.split('.')?.[1]);
        // if (mObj) {
        //   el.setting.fieldType = mObj.fieldType;
        // }
        if (fieldObj?.childSetting?.length) {
          fieldObj.childSetting?.forEach((m) => {
            if (el.field?.split('.')?.[1] == m.fieldKey) {
              el.setting = m;
            }
          });
        }
      }
    });
  });
};
// const userTree = ref({
//   checkDepartment: false,
//   isAll: false
// });
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const update = _.debounce(async () => {
  setLoading(true);
  if (!entityId.value) {
    data.ruleForm.conditions = [];
    data.ruleForm.leadsFieldList = [];
    data.lastEntityId = '';
    setLoading(false);
    return false;
  }
  childrenData.value = props.children;
  console.log('组件加载33', childrenData.value, props.defaultConditions);
  if (props.defaultConditions == 1 && childrenData.value.length == 0) {
    childrenData.value = [{ operation: 'and', field: '', fieldType: '', value: null, isGroup: true, children: [{ field: '', fieldType: '', operation: '', value: null, isGroup: false }] }];
  }
  await getFilter();
  await setConditionsFieldSetting(childrenData.value);
  await getConditions();
  await condition();
}, 100);
watch(
  () => entityId.value,
  () => {
    console.log(729, entityId.value);
    update();
  },
  {
    deep: true,
    immediate: true
  }
);

const updateCondition = () => {
  console.log('updateCondition', data.ruleForm.conditions);
  const arr = JSON.parse(JSON.stringify(data.ruleForm.conditions));
  arr?.forEach((item) => {
    item.children?.forEach((child) => {
      if (child?.field?.split('.')?.length == 2) {
        //说明是子表单
        child.field = child.field?.split('.')[0];
        child['remark'] = JSON.stringify({ entity: child.setting.entityId, fieldKey: child.setting?.fieldKey, settingId: child.setting.id });
      }
      if (Array.isArray(child.value) && (child.operation === 'in' || child.operation === 'not_in')) {
        if (Array.isArray(child.value[0]) && isCascader(child)) {
          child.value = child.value?.map((subArr) => subArr?.join('/'))?.join(',');
        } else {
          if (Array.isArray(child.value)) {
            child.value = child.value?.filter(Boolean)?.join(',');
          }
        }
      } else if (Array.isArray(child.value) && child.operation === 'between') {
        //只有日期，日期范围有‘between’操作符
        const obj = {
          beginDate: child.value[0],
          endDate: child.value[1]
        };
        const jsonObj = JSON.stringify(obj);
        child.value = jsonObj;
      } else if ((Array.isArray(child.value) && child.operation == 'equals') || child.operation == 'not_equals') {
        if (isCascader(child) && Array.isArray(child.value)) {
          child.value = child.value?.join('/');
        }
      }
      if (isPrice(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = child.value * 10000;
      }
      if (isNumber(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = Number(child.value);
      }
      // 处理百分比字段类型
      if (isPercentage(child) && child.operation != 'null' && child.operation != 'not_null') {
        if (child.value && !isNaN(Number(child.value))) {
          let fieldExt = '';
          if (child.setting.fieldType === 21) {
            if (child.setting?.business.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.numberFormat) || 2;
            }
          } else {
            if (child.setting.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.numberFormat) || 2;
            }
          }
          child.value = tools.setPercentage(child.value, fieldExt);
        }
      }
      // 处理人员字段类型
      if (isUserDepartment(child)) {
        if ((child.operation != 'null' || child.operation != 'not_null') && _.isObject(child.value)) {
          child.value = JSON.stringify({
            userIds: _.map(child.value.userIds, 'id'),
            departIds: _.map(child.value.departIds, 'id')
          });
        }
        if (props.fromPage === 'echart' && child?.userList?.length > 0) {
          //图表
          if (child?.business === null) child.business = {};
          child.business['userIds'] = child.userList?.map((v) => {
            return {
              ...v,
              name: v.userName,
              avatar: v.avatarOrigin
            };
          });
        }
      }
    });
  });
  arr?.forEach((item) => {
    if (item.children) {
      item.children?.forEach((child) => {
        console.log(960, child);
        // 返回的字段是否需要包含字段setting
        if (!props.isReturnSetting) {
          if (child.setting) delete child.setting;
        }
        // child.remark= subField ? JSON.stringify({ entity: entity, fieldKey: field, settingId: settingId }) : ''
      });
    }
  });
  return arr;
};
watch(
  data.ruleForm,
  () => {
    // 新建编辑中查找关联中的筛选条件不能开启实时监听，根据change时间回调获取条件
    if (props.fromPage !== 'associated') {
      emits('cb', updateCondition());
    } else {
      //只改变 不触发任何事件的cb
      emits('setCondition', updateCondition());
    }
  },
  { flush: 'post', deep: true }
);
const getCondition = () => {
  return updateCondition();
};
//添加
const getData = async () => {
  const errors = await editAddForm.value.validate();
  if (errors) {
    // 校验失败
    return false;
  }
  return updateCondition();
};

defineExpose({
  getData,
  getCondition,
  update
});
</script>
<style scoped lang="less">
@import './custom-field-condition.less';
</style>
<style lang="less">
.tree-select-condition {
  .arco-tree-node-title {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
